import {
  inject,
  Injectable,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { ApiService } from '../services/api-services/api.service';
import { AttendeeInformation, DATETIMEFORMART, FloorPlanInfo } from '../interfaces/interfaces';
import { catchError, firstValueFrom, map, Observable, Observer, of, Subscription, tap } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AttendeesStore {
  private _attendeesSignal: WritableSignal<AttendeeInformation[]> = signal<
    AttendeeInformation[]
  >([]);
  private _loadingSignal: WritableSignal<boolean> = signal<boolean>(false);

  public attendees: Signal<AttendeeInformation[]> =
    this._attendeesSignal.asReadonly();
  public loading: Signal<boolean> = this._loadingSignal.asReadonly();

  private apiService: ApiService = inject(ApiService);

  constructor() {}

  // Actions
  public resetStoreData() {
    this._attendeesSignal.set([]);
    this._loadingSignal.set(false);
  }

  //   Api calls
  public getAttendeesList() {
    this._loadingSignal.set(true);
    return firstValueFrom(
      this.apiService.getAllAttendeesList().pipe(
        tap((attendees: AttendeeInformation[]) => {
          this._attendeesSignal.set(attendees);
          this._loadingSignal.set(false);
        }),
        catchError((error) => {
          console.error('Error fetching attendees', error);
          this._loadingSignal.set(false);
          return of([]);
        })
      )
    );
  }

  public checkAttendeeAvailability(attendeesUPN: string[], startTime: string, endTime: string) : Promise<{ [key: string]: boolean }> {
    const startTimeUTC = moment(startTime).utc().format(DATETIMEFORMART);
    const endTimeUTC = moment(endTime).utc().format(DATETIMEFORMART);
   return firstValueFrom(this.apiService.checkAttendeeAvailability(attendeesUPN, startTimeUTC, endTimeUTC).pipe(
    map(res => res)
   ))
  }

  public setAttendeesList(attendees: AttendeeInformation[]) {
    this._attendeesSignal.set(attendees);
  }

 
  //   Helpers
  public extendAttendeeInformation(
    attendees: AttendeeInformation[]
  ): AttendeeInformation[] {
    attendees.forEach((attendee) => {
      let temp = this.attendees().find(
        (person) =>
          person.userPrincipalName.toLowerCase() ==
          attendee.userPrincipalName.toLowerCase()
      );
      if (temp?.firstName && temp?.lastName) {
        attendee.firstName = temp.firstName;
        attendee.lastName = temp.lastName;
      } else {
        attendee.firstName = attendee.userPrincipalName;
        attendee.lastName = '';
      }
    });
    return attendees;
  }

  findAttendee(attendee: AttendeeInformation,searchTerm: string) {
    if(searchTerm == '') return true;
    return (attendee.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      attendee.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      attendee.userPrincipalName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
}
